import { proxy } from 'valtio';

class Store {
  historicalImageryMapIndices: { [key: number]: boolean } = { 0: false };

  setIsEnabled(index: number, isEnabled: boolean) {
    this.historicalImageryMapIndices[index] = isEnabled;
  }

  reset(index?: number) {
    if (index === undefined) {
      this.historicalImageryMapIndices = {};
    } else {
      this.historicalImageryMapIndices[index] = false;
    }
  }
}

const historicalImageryStore = proxy(new Store());
export default historicalImageryStore;
